import { GetServerSideProps } from "next";

import { PressRelease, getPressReleaseBySlug } from "@clients/afaseApiClient";
import Meta from "@components/Meta/meta";
import Layout from "@containers/Layout/layout";
import PressReleasePage from "@containers/PressReleasePage";
import { Event, trackEvent } from "@utils/events";
import { ImageType, socialMediaDefaultImage } from "@utils/imageHelpers/imageHelper";
import { getBaseUrl } from "@utils/urlResolver";

import { GetSiteTreeStructure } from "services/SiteTreeStructureFactory";
import { UrlStructureService } from "services/UrlStructureService";
import { getLayoutData } from "services/layoutService";

type PageProps = {
  pressRelease: PressRelease;
  currentUrl: string;
  layoutData: any;
};

const Page = ({ pressRelease, currentUrl, layoutData }: PageProps) => {
  const images = pressRelease?.images ?? {};
  const soMeImage = images[ImageType.metaImage];
  return (
    pressRelease && (
      <Layout {...layoutData}>
        <Meta
          title={"Pressrum"}
          image={soMeImage?.url || `${getBaseUrl()}${socialMediaDefaultImage?.url}`}
          imageAlt={soMeImage?.title || socialMediaDefaultImage?.imageAltText}
          description={pressRelease?.preamble}
          ogTitle={pressRelease?.heading}
          url={currentUrl}
          canonicalUrl={currentUrl}
          breadcrumbs={layoutData?.siteHeaderData?.breadCrumbLinks}
        />
        <PressReleasePage pressRelease={pressRelease} />
      </Layout>
    )
  );
};

export default Page;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const preview = process.env.FORCE_PREVIEW === "true" || context.preview || false;
  const { params, resolvedUrl } = context;

  trackEvent(Event.GET_SERVER_SIDE_PROPS, {
    path: resolvedUrl,
    preview,
  });

  const pressRelease = await getPressReleaseBySlug(String(params.slug));

  if (!pressRelease) {
    return { notFound: true };
  }

  const [urlStructure, siteTreeStructure] = await Promise.all([
    UrlStructureService(preview),
    GetSiteTreeStructure(preview),
  ]);

  return {
    props: {
      layoutData: await getLayoutData(urlStructure, siteTreeStructure, resolvedUrl, preview, true),
      pressRelease,
      currentUrl: `${process.env.NEXT_PUBLIC_BASE_URL}${resolvedUrl}`,
    },
  };
};
